{
  "version": 1,
  "asset_id": "7aa8d881-00d5-4443-aeab-6ed70beac2ff",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/7aa8d881-00d5-4443-aeab-6ed70beac2ff/aleph-animal-1920.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/7aa8d881-00d5-4443-aeab-6ed70beac2ff/aleph-animal-1920.webp",
  "original_filename": "aleph-animal-1920.webp",
  "size": 245094,
  "content_type": "image/webp",
  "created_at": "2026-10-20T23:04:51Z"
}
